// React Imports
import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import {Input, Tooltip} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Typography from "@mui/material/Typography";

// App Imports
import {
    addChildContracts,
    advanceContract,
    createNewContract,
    getQueueC
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import {updateExistingExpressions} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";


import PropTypes from 'prop-types';
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import WorkQueueContractInfoDialogue from "./Info/WorkQueueCotnractInfoDialogue";
import {useState} from "react";



export default function ContractAddFromGridDialogue() {
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState('Dione');
    const [workQueueContractInfoOpen, setWorkQueueContractInfoOpen] = useState(false);



    const selectorContractName = useSelector((state) => state.workQueueSlc.value.selectedContractName);

function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const radioGroupRef = React.useRef(null);

    const currentUserId = useSelector((state) => state.userProfileSlc.value.userId);
    const currentUserName = useSelector((state) => state.userProfileSlc.value.userName);
    const currentUserContractType = useSelector((state) => state.userProfileSlc.value.userContractType);



    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    // const selectorContractName = useSelector((state) => state.workQueueSlc.value.selectedContractName);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.selectedContractLevel);
    const selectorContractProduct = useSelector((state) => state.workQueueSlc.value.selectedContractProductId);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.selectedContractGuild);
    const [contractCount, setContractCount] = React.useState(1);


    const dispatchData = useDispatch();

    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);

    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    // const dialogText = () => {
    //     if (selectorContractLevel === 'Guild') {
    //         'Hi hi';
    //     }
    // };

    const handleCancel = () => {
        onClose();
        setContractCount(1);
    };

    const handleOk = () => {
        onClose();
        console.log("handleOk triggered from Add Contract(s) from Grid dialogue");
        console.log("selectorContractId = ", selectorContractId);
        if(selectorContractId > 0) {
// trigger function
            console.log("adding contract(s) from contract grid");
            console.log("adding to this contract via selectorContractId ", selectorContractId);
            sonole.log("adding this many new contracts ", contractCount)
            dispatchData(changeWorkSubmitting({submitting: true }));
            addChildContracts(selectorContractId, contractCount)
                .then(()=>dispatchData(changeWorkQueue({workQueueCGridRefresh: true})))
            // }else{createNewDataSet()
            // }else{createNewContract(currentUserId, currentUserName, currentUserContractType)
        }else{createNewContract(currentUserId, currentUserName, currentUserContractType)

            .then(data => {
                dispatchData(changeWorkQueue({
                    selectedContractId: data, selectedContractStatus: "NEW" , cId: data,
                    selectedContractSectionId: 0,
                    workQueueCSGridRefresh: true,
                    workQueueCDPGridRefresh: true
                }));
                dispatchData(changeWorkSubmitting({submitting: false }));
                console.log('This is my newly generated contract id', data);
                // console.log(data);
                advanceContract(data).then(() => {
                    // callback(fetchWorkQueueCDP);
                    // dispatchData(changeWorkQueue({workQueueAdvanceState: true}));
                    console.log("Advance Contract: ",data );
                    // console.log(selectorContractId);
                })
                    .then(() => {
                        updateExistingExpressions(data);
                    })
                    .then(() => {
                        getQueueC()

                            .then(data => {
                                console.log("get Queue C: ",data );
                                dispatchData(changeWorkSubmitting({submitting: false }));

                            })
                        // dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
                        // dispatchData(changeWorkQueue({workQueueCDPGridRefresh: true}));
                    })            .finally(()=>{
                    dispatchData(changeWorkSubmitting({submitting: false }));});
            })}
// .then(() => {
//                 dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));})
        //     });
        // setContractCount(1);
        console.log("here's my contract data: id = ",selectorContractId, " count = ", contractCount);

    };
    //
    // function onSubmit(contractCount) {
    //     // function onSubmit(data) {
    //     // setSubmitting(true)
    //     // setContractDataPointValueId(props.contractDataPointValueIdX)
    //     console.log("here's my contractDataPointValue data")
    //     console.log({contractCount})
    //     // console.log("here's my stringify data")
    //     // console.log(JSON.stringify(data, null, 2))
    // };

    const handleChange = (event) => {
        setContractCount(event.target.value);
    };

    const handleContractCountChange = (contractEvent) => {
        // contractFilter = contractEvent.target.value;
        setContractCount(contractEvent.target.value[0]);
        console.log("This is my contract count");
        console.log(contractEvent.target.value[0])
        // fetchDestinationSections()

    };

    //
    // const {register, handleSubmit} = useForm();


    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            TransitionProps={{ onEntering: handleEntering }}
            open={open}
            {...other}
        >
            <DialogTitle>Add Contract</DialogTitle>
            <DialogContent dividers>
                {/*<form*/}
                {/*    onSubmit={handleSubmit((data)=>        onSubmit(data))}*/}
                {/*>*/}
                {selectorContractId === 0 && <Typography>Start a new contract from scratch</Typography>}
                {/*<p>Add x cast-level contracts under this contract</p>*/}
                {/*<Typography>{selectorContractLevel === null && ''}*/}

                {/*<p>{selectorContractId}</p>*/}
                {/*<p>{selectorContractName}</p>*/}
                {/*<p>{selectorContractLevel}</p>*/}
                {selectorContractId !== 0 && <div>
                    {/*<Stack direction="row" spacing={1}>*/}
                    <Typography>Add </Typography>
                    <Input
                        // defaultValue= "1"
                        value= {contractCount}
                        onChange={handleChange}
                        sx={{ width: 50 }}
                    />
                    {selectorContractLevel === 'Guild' &&  <Typography> Cast-level contract(s) under </Typography>}
                    {(selectorContractLevel === 'Cast' && selectorContractGuild === 'SAG') &&  <Typography> Engagement-level contract(s) under </Typography>}
                    {/*</Stack>*/}
                    <Typography>Contract {selectorContractName} ({selectorContractId})</Typography>
                    <Typography>within {selectorContractGuild} on Product {selectorContractProduct}</Typography></div>}
                {/*<RadioGroup*/}
                {/*    ref={radioGroupRef}*/}
                {/*    aria-label="ringtone"*/}
                {/*    name="ringtone"*/}
                {/*    value={value}*/}
                {/*    onChange={handleChange}*/}
                {/*>*/}
                {/*    {options.map((option) => (*/}
                {/*        <FormControlLabel*/}
                {/*            value={option}*/}
                {/*            key={option}*/}
                {/*            control={<Radio />}*/}
                {/*            label={option}*/}
                {/*        />*/}
                {/*    ))}*/}
                {/*</RadioGroup>*/}
                {/*</form>*/}
            </DialogContent>
            <DialogActions>
                <Button  onClick={handleCancel}>
                    Cancel
                </Button>
                <Button autoFocus onClick={handleOk}>Okay</Button>
                {/*<Button type= "submit" autoFocus onClick={onSubmit()}>Ok</Button>*/}
            </DialogActions>

        </Dialog>
    );
}

ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
};


    const handleAdd = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

    };


    const handleWorkQueueContractInfo = () => {
        setWorkQueueContractInfoOpen(true);
    };

    const handleCloseWorkQueueContractInfo = () => {
        setWorkQueueContractInfoOpen(false);
    };


    const selectorExpansionDepth = useSelector((state) => state.workSlc.value.expansionDepth);

    return (
        // <Stack direction="row" spacing={1}>
        // <Box sx={{  height: 24, verticalAlign: 'top'}}>
        // <IconButton
        //     color="primary"
        //     size="medium"               // large icon & hit area
        //     onClick={handleAdd}
        //     sx={{verticalAlign: 'top'}}
        //     // sx={{ ml: 1 }}
        // >
        //     <Tooltip title={"Add Contract"}>
        //
        //         <AddCircleOutlineIcon
        //             sx={{verticalAlign: 'top'}}
        //         />
        //
        //     {/*        // fontSize="medium" color={'primary'}*/}
        //     {/*        // aria-haspopup="true"*/}
        //     {/*        // aria-controls="xxx"*/}
        //     {/*        // aria-label="xxx1"*/}
        //     {/*// onClick={handleAdd}/>*/}
        //     </Tooltip>
        // </IconButton>
        //     <ConfirmationDialogRaw
        //         id="xxx1"
        //         keepMounted
        //         open={open}
        //         onClose={handleClose}
        //         value={value}
        //     />
        // </Box>
        //     <Box>
        //         <Typography
        //             sx={{ fontWeight: 'bold' }}
        //             style={{cursor: 'pointer'}}
        //         >Contracts</Typography>
        //     </Box>
        // </Stack>


        <Stack direction="row" spacing={1} alignItems="center">   {/* ← vertical center */}
            <Tooltip title="Add Contract">
                <IconButton
                    color="primary"
                    size="small"              // or "medium" if you want bigger
                    onClick={handleAdd}
                    sx={{ p: 0.5 }}          // optional: trims extra padding
                >
                    <AddCircleOutlineIcon />
                </IconButton>
            </Tooltip>
            <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
            <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }}
                        onClick={() => handleWorkQueueContractInfo()}
            >
                Contracts
            </Typography>
            </Tooltip>
                <WorkQueueContractInfoDialogue
                    open={workQueueContractInfoOpen}
                    onClose={handleCloseWorkQueueContractInfo}
                />

            {/*<Tooltip title="Collapse All">*/}
            {/*    <IconButton*/}
            {/*        size="small"*/}
            {/*        // onClick={(e) => {*/}
            {/*        //     e.stopPropagation();*/}
            {/*        //     stepDepth(-1);        // or collapseAll()*/}
            {/*        // }}*/}
            {/*        onClick={() => {*/}
            {/*            dispatchData(changeWork({expansionDepth: 0}));}}*/}
            {/*        aria-label="collapse all expansion depth"*/}
            {/*    >*/}
            {/*        /!*<UnfoldLessDouble fontSize="small" />*!/*/}
            {/*        <Icon className="material-symbols-outlined">unfold_less_double</Icon>*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            {/*<Tooltip title="Decrease depth (Collapse)">*/}
            {/*    <IconButton*/}
            {/*        size="small"*/}
            {/*        // onClick={(e) => {*/}
            {/*        //     e.stopPropagation();*/}
            {/*        //     stepDepth(-1);        // or collapseAll()*/}
            {/*        // }}*/}
            {/*        onClick={() => {*/}
            {/*            dispatchData(changeWork({expansionDepth: selectorExpansionDepth - 1}));}}*/}
            {/*        aria-label="decrease expansion depth"*/}
            {/*    >*/}
            {/*        <UnfoldLess fontSize="small" />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}

            {/*<Tooltip title="Increase depth (Expand)">*/}
            {/*    <IconButton*/}
            {/*        size="small"*/}
            {/*        // onClick={(e) => {*/}
            {/*        //     e.stopPropagation();*/}
            {/*        //     stepDepth(+1);        // or expandAll()*/}
            {/*        // }}*/}
            {/*        onClick={() => {*/}
            {/*            dispatchData(changeWork({expansionDepth: selectorExpansionDepth + 1}));}}*/}
            {/*        aria-label="increase expansion depth"*/}
            {/*    >*/}
            {/*        <UnfoldMore fontSize="small" />*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}

            {/*<Tooltip title="Expand all">*/}
            {/*    <IconButton*/}
            {/*        size="small"*/}
            {/*        // onClick={(e) => {*/}
            {/*        //     e.stopPropagation();*/}
            {/*        //     stepDepth(+1);        // or expandAll()*/}
            {/*        // }}*/}
            {/*        onClick={() => {*/}
            {/*            dispatchData(changeWork({expansionDepth: -1}));}}*/}
            {/*        aria-label="expand all"*/}
            {/*    >*/}
            {/*        /!*<UnfoldMoreDouble fontSize="small" />*!/*/}
            {/*        <Icon className="material-symbols-outlined">unfold_more_double</Icon>*/}
            {/*    </IconButton>*/}
            {/*</Tooltip>*/}
            <Typography sx={{
                fontWeight: 'bold',
                pl: 2}}
            >{selectorContractName}</Typography>
        </Stack>



        // <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        //     <List component="div" role="group">
        //         <ListItem button divider disabled>
        //             <ListItemText primary="Interruptions" />
        //         </ListItem>
        //         <ListItem
        //             button
        //             divider
        //             aria-haspopup="true"
        //             aria-controls="ringtone-menu"
        //             aria-label="phone ringtone"
        //             onClick={handleClickListItem}
        //         >
        //             <ListItemText primary="Phone ringtone" secondary={value} />
        //         </ListItem>
        //         <ListItem button divider disabled>
        //             <ListItemText primary="Default notification ringtone" secondary="Tethys" />
        //         </ListItem>
        //         <ConfirmationDialogRaw
        //             id="ringtone-menu"
        //             keepMounted
        //             open={open}
        //             onClose={handleClose}
        //             value={value}
        //         />
        //     </List>
        // </Box>
    );
}